import { ErrorHandler, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { storageAvailable } from '../../util/helpers';
import { PinSearchbarService } from '../../shared/services/pin-searchbar.service';
var BusinessPageComponent = /** @class */ (function () {
    function BusinessPageComponent(_route, _router, _meta, _title, _errorHandler, _pinSearchbarService) {
        this._route = _route;
        this._router = _router;
        this._meta = _meta;
        this._title = _title;
        this._errorHandler = _errorHandler;
        this._pinSearchbarService = _pinSearchbarService;
        this.isPinChecked = false;
    }
    BusinessPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (storageAvailable('localStorage')) {
            var storageVal = localStorage.getItem('searchbarPinned');
            this.isPinChecked = storageVal === 'true';
        }
        this._route.data
            .subscribe(function (data) {
            _this.business = data.business;
            _this._updateMeta(data.business);
        }, function (error) {
            _this._errorHandler.handleError(error);
        });
    };
    BusinessPageComponent.prototype._updateMeta = function (business) {
        var title = business.name;
        var airport = this.business.airports[0];
        if (airport) {
            title += " at " + airport.identifier;
        }
        this._title.setTitle(title + " - " + environment.appName);
        this._meta.removeTag('name="description"');
    };
    Object.defineProperty(BusinessPageComponent.prototype, "airportIdent", {
        /**
         * Returns the airport identifier to use for the "Back to [airport]" link in the header. If the user navigated to
         * the business page from an airport page, then the referer airport should be used (stored in sessionStorage).
         * Otherwise, this will use the first associated airport for the business. If the business is not associated with
         * any airport, this will return null.
         * @returns {string|null}
         */
        get: function () {
            if (!this.business) {
                return null;
            }
            // Get the associated airports (usually, there is only one, but a business may be associated with multiple
            // airports)
            var associatedAirports = this.business.airports || [];
            // Check if there was an airport set in sessionStorage, and that airport is associated with this business.
            if (storageAvailable('sessionStorage')) {
                var lastAirport_1 = sessionStorage.getItem('lastAirport');
                if (lastAirport_1 && associatedAirports.some(function (airport) { return airport.identifier === lastAirport_1; })) {
                    return lastAirport_1;
                }
            }
            // Otherwise, return the identifier of the first associated airport (or null if there are no associated airports).
            return associatedAirports.length ? associatedAirports[0].identifier : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessPageComponent.prototype, "searchReturnUrl", {
        /**
         * The business-finder search results URL to return to, when the user arrived here from a Flight School or
         * University Finder search (both open businesses at /business/:id). It is set by those finders' results
         * listing / map marker click; the most recent finder search wins. Used by the "Back to Search" link.
         * @returns {string|null}
         */
        get: function () {
            if (!storageAvailable('sessionStorage')) {
                return null;
            }
            return sessionStorage.getItem('businessFinderSearchReturn');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessPageComponent.prototype, "cameFromSearch", {
        get: function () {
            return !!this.searchReturnUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessPageComponent.prototype, "backLabel", {
        /**
         * Text for the "Back to ..." link: the originating search when the user came from the Flight School Finder,
         * otherwise the associated airport (or "Search" when there is none).
         * @returns {string}
         */
        get: function () {
            if (this.cameFromSearch) {
                return 'Search';
            }
            if (this.airportIdent) {
                return this.airportIdent.toUpperCase().startsWith('ZZ') ? 'airport' : this.airportIdent;
            }
            return 'Search';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Navigates back to wherever the user came from: the Flight School Finder results (preserving the query)
     * when that is the origin, otherwise the associated airport page, falling back to a fresh search.
     */
    BusinessPageComponent.prototype.goBack = function () {
        var returnUrl = this.searchReturnUrl;
        if (returnUrl) {
            this._router.navigateByUrl(returnUrl);
            return;
        }
        if (this.airportIdent) {
            if (this.business && (this.business.sourceId === 10 || this.business.sourceId === 12)) {
                this._router.navigate(['/airports', this.airportIdent, 'island']);
            }
            else {
                this._router.navigate(['/airports', this.airportIdent]);
            }
            return;
        }
        this._router.navigate(['/search']);
    };
    BusinessPageComponent.prototype.onChange = function (ob) {
        this.isPinChecked = ob.checked;
        if (storageAvailable('localStorage')) {
            localStorage.setItem('searchbarPinned', '' + this.isPinChecked);
        }
        this._pinSearchbarService.pinSearchbarClicked(this.isPinChecked);
    };
    return BusinessPageComponent;
}());
export { BusinessPageComponent };
